import { useAtomValue } from 'jotai';
import { useFlag } from '@localagent/sdk/react';
import { sdkAtom, bridgeEventStreamAtom, daemonPushFrameStreamAtom } from '../stores/sdk/atoms';

/**
 * App-shell binding of the SDK's {@link useFlag}:
 * pull on mount, re-evaluate live on a change frame — `flags.changed` on the
 * web cloud bridge (bridge ADR-003), the daemon's `flags.updated` relay on
 * desktop. Exactly one of the two streams is published per platform.
 */
export function useFeatureFlag(key: string): boolean {
  const sdk = useAtomValue(sdkAtom);
  const stream = useAtomValue(bridgeEventStreamAtom);
  const daemonStream = useAtomValue(daemonPushFrameStreamAtom);
  return useFlag(sdk, stream, key, daemonStream);
}
